import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { Badge } from '@/components/ui/badge';
import SortableDealCard from './SortableDealCard';

interface DroppableStageProps {
  stage: any;
  deals: any[];
  onDealClick: (deal: any) => void;
}

export default function DroppableStage({ stage, deals, onDealClick }: DroppableStageProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: `stage-${stage.id}`,
  });

  return (
    <div className="w-72 flex-shrink-0">
      {/* Stage Header */}
      <div className="flex items-center justify-between mb-3">
        <div>
          <h3 className="font-medium">{stage.name}</h3>
          <p className="text-xs text-muted-foreground">
            {deals.length} deals
          </p>
        </div>
        <Badge variant="secondary" className="text-xs">
          {stage.probability}%
        </Badge>
      </div>
      
      {/* Droppable Area */}
      <div
        ref={setNodeRef}
        className={`space-y-3 min-h-[500px] p-2 rounded-lg transition-colors ${
          isOver ? 'bg-muted/50' : ''
        }`}
      >
        <SortableContext items={deals.map(deal => deal.id)} strategy={verticalListSortingStrategy}>
          {deals.map((deal) => (
            <SortableDealCard
              key={deal.id}
              deal={deal}
              onClick={onDealClick}
            />
          ))}
        </SortableContext>
      </div>
    </div>
  );
} 